import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface CodeBlockProps {
  code: string;
  language?: string;
  title?: string;
}

export function CodeBlock({ code, language, title }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="relative">
      {title && (
        <div className="flex items-center justify-between bg-gray-700 px-4 py-2 rounded-t-lg">
          <span className="text-sm text-gray-300 font-medium">{title}</span>
          {language && (
            <span className="text-xs text-gray-400 uppercase">{language}</span>
          )}
        </div>
      )}

      <div className="relative">
        <pre className={`bg-gray-900 p-4 ${title ? '' : 'rounded-lg'} ${title ? 'rounded-b-lg' : ''} overflow-x-auto`}>
          <code className="text-sm text-gray-100 font-mono whitespace-pre">
            {code}
          </code>
        </pre>

        <button
          onClick={handleCopy}
          className="absolute top-2 right-2 p-2 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors"
          title={copied ? 'Copied!' : 'Copy to clipboard'}
        >
          {copied ? (
            <Check className="w-4 h-4 text-green-500" />
          ) : (
            <Copy className="w-4 h-4 text-gray-400" />
          )}
        </button>
      </div>
    </div>
  );
}
